module.exports = ".custom-padding {\n  padding: 1.25rem 1.25rem 0 1.25rem; }\n"